// /frontend/src/pages/dashboard/post/previews/YouTubePreview.js
import React from 'react';

const VIDEO_EXT   = ['.mp4', '.mov', '.webm', '.m4v', '.avi'];
const PLACEHOLDER = 'https://placehold.co/32x32/FF0000/FFFFFF?text=YT';
const isVideo = (url = '') => VIDEO_EXT.some((e) => url.toLowerCase().endsWith(e));

export default function YouTubePreview({
  account,
  files,
  caption,
  postType,
  scheduleDateTime,
}) {
  /* media ---------------------------------------------------------------- */
  const main       = files.length ? files[0].url : null;
  const forceShort = account?.options?.forceShort ?? false;

  const shortFrame = { width: 180, height: 320 };  // 9��16
  const wideFrame  = { width: 480, height: 270 };  // 16��9
  const frame      = forceShort ? shortFrame : wideFrame;

  /* meta ----------------------------------------------------------------- */
  const avatar      =
    account?.userAvatar || account?.profileImage || account?.avatarUrl || PLACEHOLDER;
  const displayName = account?.displayName || 'Channel name';

  /* title & description */
  const ytTitle = account?.options?.title?.trim()
                   || caption?.trim()
                   || 'Video title will appear here';
  const ytDesc  = caption?.trim() || '';

  return (
    <div
      className="border rounded bg-white mb-3"
      style={{ width: frame.width + 60, fontFamily: 'Roboto, Arial, sans-serif' }}
    >
      {/* thumbnail / video ------------------------------------------------- */}
      <div className="bg-dark d-flex justify-content-center align-items-center">
        {main ? (
          isVideo(main) ? (
            <video src={main} muted style={{ ...frame, objectFit: 'cover' }} />
          ) : (
            <img src={main} alt="thumb" style={{ ...frame, objectFit: 'cover' }} />
          )
        ) : (
          <div
            className="bg-light text-muted d-flex align-items-center justify-content-center"
            style={{ ...frame }}
          >
            No media selected
          </div>
        )}
      </div>

      {/* meta strip ------------------------------------------------------- */}
      <div className="d-flex align-items-start p-2" style={{ gap: 8 }}>
        <img
          src={avatar}
          alt="avatar"
          className="rounded-circle"
          style={{ width: 32, height: 32, objectFit: 'cover' }}
        />
        <div className="flex-grow-1">
          {/* Title */}
          <div className="fw-semibold" style={{ lineHeight: 1.2 }}>
            {ytTitle}
          </div>

          {/* Channel + time */}
          <small className="text-muted">
            {displayName}
            {' �� '}
            {postType === 'schedule' && scheduleDateTime
              ? new Date(scheduleDateTime).toLocaleString()
              : 'Just now'}
          </small>

          {/* Description (caption) */}
          {ytDesc && (
            <div className="mt-1" style={{ fontSize: 14, whiteSpace: 'pre-wrap' }}>
              {ytDesc}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
